import React, { useEffect, useState } from "react";
import {
  DocuType,
  DocuTypeObj,
  DocuTypeService,
} from "../../model/backoffice/document-type";
import { GetCreateTable } from "../../core/Helper2";
import DocutypeEditor from "./b0002-docutype-editor";
import ConfirmDialogB, { ConfirmDefault } from "../components/ConfirmDialogB";
import { useSelector } from "react-redux";
import { TopToolBar } from "../../core/TopToolbar";

export default function DocutypeList() {
  const userInfo = useSelector((state) => state.user.detail);
  const _idFiledsName = "DocuTypeId";

  const [table, setTable] = useState();
  const [data, setData] = useState([]);
  const [editor, setEditor] = useState({ show: false });

  const [confirm, setConfirm] = useState(ConfirmDefault);

  useEffect(() => {
    getData();
    return () => {
      setData([]);
      setTable(null);
      setEditor(null);
    };
  }, []);

  //**Create Table Effected Data */
  useEffect(() => {
    setTable(
      GetCreateTable({
        idFieldName: _idFiledsName,
        columns: DocuTypeService.GetColumns(
          DocuTypeObj,
          actionEdit,
          actionDelete
        ),
        data: data,
      })
    );
  }, [data]);

  /** Action table button clicking */

  /** NEW */
  const actionAddNew = () => {
    showEditor(0);
  };
  /** EDIT */
  const actionEdit = (x, row) => {
    showEditor(row[_idFiledsName]);
  };

  /** EDITOR  */
  const showEditor = (idValue) => {
    setEditor((pv) => ({
      ...pv,
      show: true,
      idFieldName: _idFiledsName,
      idValue: idValue,
      action: () => {
        getData();
      },
    }));
  };

  /**DELETE */
  const actionDelete = async (x, row) => {
    setConfirm((pv) => ({
      ...pv,
      show: true,
      action: async (ok) => {
        if (ok) {
          let res = await DocuTypeService.DeleteItem(
            { [_idFiledsName]: row[_idFiledsName] },
            userInfo
          );
          if (res) {
            getData();
          }
        } else {
          setConfirm(ConfirmDefault);
        }
      },
    }));
  };

  /**
   * GetdataInfo
   */
  const getData = async (text) => {
    let result = await DocuTypeService.GetList({ text: text ?? "" });
    if (result) {
      setData(result ?? []);
    }
  };

  const searchHandler = (text) => {
    getData(text);
  };

  return (
    <div>
      <TopToolBar
        onAddNew={actionAddNew}
        title={"ประเภทเอกสาร"}
        searchHandler={searchHandler}
      />
      {table}
      <DocutypeEditor {...{ editor: [editor, setEditor] }} />
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
    </div>
  );
}
